var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.8002H7.4H50.6",
    stroke: "#195C72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1999 12.8V50.6C45.1999 52.0322 44.631 53.4057 43.6183 54.4184C42.6056 55.4311 41.2321 56 39.7999 56H12.7999C11.3677 56 9.99422 55.4311 8.98153 54.4184C7.96883 53.4057 7.3999 52.0322 7.3999 50.6V12.8M15.4999 12.8V7.4C15.4999 5.96783 16.0688 4.59432 17.0815 3.58162C18.0942 2.56893 19.4677 2 20.8999 2H31.6999C33.1321 2 34.5056 2.56893 35.5183 3.58162C36.531 4.59432 37.0999 5.96783 37.0999 7.4V12.8",
    stroke: "#195C72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9004 26.3002V42.5002",
    stroke: "#195C72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6992 26.3002V42.5002",
    stroke: "#195C72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon _trash.d91284f4.svg";
export { ForwardRef as ReactComponent };